import { render, staticRenderFns } from "./GDPRAgreement.vue?vue&type=template&id=8fe5a34e"
import script from "./GDPRAgreement.vue?vue&type=script&lang=ts"
export * from "./GDPRAgreement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports